module.exports = __webpack_public_path__ + "img/图片11.96864999.png";